import { fieldHoc } from './fieldHoc';
import { FieldUi } from './FieldUi';
export const Field = fieldHoc(FieldUi);
//# sourceMappingURL=es/Other/Field/Field.js.map